import { scmsService } from "../services/site";
import { settings } from "../common/setting";
import { cr, URLS } from "fire-wind-water";
import { Email } from "../common/Email";
import * as $ from "jquery";
import { user } from "../user/index";
class File extends Email {
  $skelem = ".sk-component.FILE";
  $user: any = {};
  isLogin = false;
  isPreview: boolean = settings.isPreview;
  isDesign: boolean = settings.isDesign;
  fileDetail = "";
  tid: string = settings.tenantId || URLS.getURL("tid") || (window['siteParams']?window['siteParams'].tid:null);
  sid: string = settings.siteId || URLS.getURL("sid") || (URLS.getURL("des")?null : (window['siteParams']?window['siteParams'].sid:null));
  cy: string = settings.category || URLS.getURL("cy") || (URLS.getURL("des")?null : (window['siteParams']?window['siteParams'].cy:null));
  t: string = settings.t || URLS.getURL("t") || (URLS.getURL("des")?null : (window['siteParams']? window['siteParams'].t:null));
  menuId: string = settings.menuId || URLS.getURL("menuId");
  pid = "";
  currentFid = "";
  constructor() {
    super();
    $sk.template.module(this);
  }

  skAfterViewChecked(): void {
    if (this.isPreview) {
      cr.each(settings.page.items, (d) => {
        if (d.usePages === "fileinfo") {
          this.pid = d.id;
          this.fileDetail = this.menuId
            ? `./fileInfo.html?tid=${this.tid}&sid=${this.sid}&pid=${this.pid}&cy=${this.cy}&t=${this.t}&menuId=${this.menuId}`
            : `./fileInfo.html?tid=${this.tid}&sid=${this.sid}&pid=${this.pid}&cy=${this.cy}&t=${this.t}`;
        }
      });
    }
  }

  skUserEnd() {
    this.updateUser();
  }

  skUserChange() {
    this.updateUser();
  }

  updateUser() {
    const m = $sk.template.get();
    if (m.user.session) {
      this.isLogin = true;
      this.$user.session = m.user.session;
    } else {
      this.isLogin = false;
    }
  }
}

export { File };
